module.exports = __webpack_public_path__ + "img/img10-2.0b10ce6d.svg";